
<template>
  <section>
    <compWrapper
      :title="
        $t('global.common.base_information', { defaultValue: '基本信息' })
      "
      theme="primary"
    >
      <compFormQuery
        v-if="type === 'query'"
        class="margin-layout"
        :formdata="getBase"
        :value="formData"
        placeholder="--"
      />
      <compFormEdit
        v-else
        class="margin-layout"
        :formdata="getBase"
        v-model="formData"
        placeholder="--"
      />
    </compWrapper>
    <compWrapper
      :title="
        $t('fbb.inbound.order_inbound_info', { defaultValue: '入库信息' })
      "
      theme="primary"
    >
      <compProductInfo
        v-if="formData.inboundPlanOrderId"
        class="margin-layout"
        :inboundPlanOrderId="formData.inboundPlanOrderId"
        :needBox="formData.needBox == 1"
      ></compProductInfo>
      <vButtonGroup v-if="getStatusBtns.length" slot="footer">
        <vButton
          v-for="item in getStatusBtns"
          :key="item.name"
          @click="item.run"
          :theme="item.theme"
          >{{ item.name }}</vButton
        >
      </vButtonGroup>
    </compWrapper>
    <compModal
      v-model="modalProps.show"
      v-bind="modalProps"
      @on-close="modalProps.show = false"
      @on-confirm="cancel"
    ></compModal>
    <compPhotoLog v-if="type === 'query'" v-bind="photoData"></compPhotoLog>
    <compLog
      v-if="type === 'query'"
      wrapper
      :columns="getLogColumns"
      :data="logList"
    ></compLog>
  </section>
</template>
<script>
import {
  HttpInboundOrder,
  HttpUpdateInboundOrder,
  HttpConfirmInboundOrder,
  HttpCancelInboundOrder,
  HttpInboundBill,
  HttpInboundOrderLogList,
} from "@/service/inbound";
import compProductInfo from "./productinfo";
import mixin from "../mixin";

export default {
  mixins: [mixin],
  components: {
    compWrapper: () => import("@components/templates/wrapper"),
    compFormQuery: () => import("@components/templates/formquery"),
    compFormEdit: () => import("@components/templates/formedit"),
    compModal: () => import("@components/templates/modal"),
    compLog: () => import("@components/templates/log"),
    compProductInfo,
  },
  data() {
    return {
      loading: false,
      type: this.$route.params.type,
      id: this.$route.query.id,
      logList: [], //log,
      modalProps: {
        show: false,
      },
      formData: {
        inboundPlanOrderId: "",
      },
      photoData: {},
    };
  },
  created() {
    this.getDetail();
  },
  computed: {
    getStatus() {
      return this.formData.inboundOrderStatus;
    },
    /**
     * 根据状态显示不同按钮
     */
    getStatusBtns() {
      const type = this.type,
        getStatus = this.getStatus;
      const btnlist = [
        {
          name: this.$t("global.common.save", { defaultValue: "保存" }),
          show:
            getStatus == 0 &&
            type === "edit" &&
            this.handleAuth("fbb.inboundorder.edit"),
          theme: "primary",
          run: this.save,
        },
        {
          name: this.$t("global.datepicker.confirm", { defaultValue: "确认" }),
          show: getStatus == 0 && this.handleAuth("fbb.inboundorder.edit"),
          theme: "success",
          run: this.confirm,
        },
        {
          name: this.$t("global.common.operation_cancel", {
            defaultValue: "取消",
          }),
          show: getStatus == 0 && type === "query",
          theme: "error" && this.handleAuth("fbb.inboundorder.edit"),
          run: this.cancelOrder,
        },
        {
          name: this.$t("global.common.return", { defaultValue: "返回" }),
          show: true,
          // theme: '',
          run: this.cancel,
        },
      ];

      return btnlist.filter((item) => item.show);
    },
    isEdit() {
      return this.type === "edit";
    },
    getBase() {
      return [
        {
          label: this.$t("fbb.inbound.order_order_no", {
            defaultValue: "入库单号",
          }),
          key: "inboundOrderNo",
          query: true,
        },
        {
          label: this.$t("global.common.status", { defaultValue: "状态" }),
          key: "inboundOrderStatus",
          query: true,
          options: this.getOrderStatus,
        },
        {
          label: this.$t("fbb.inbound.storage_number", {
            defaultValue: "入库计划单号",
          }),
          key: "inboundPlanOrderNo",
          query: true,
        },
        {
          label: this.$t("global.common.source_number", {
            defaultValue: "来源单号",
          }),
          key: "sourceNo",
          required: false,
        },
        {
          label: this.$t("global.common.warehouse", { defaultValue: "仓库" }),
          key: "orgWarehouseCode",
          query: true,
        },
        {
          label: this.$t("global.common.project", { defaultValue: "项目" }),
          key: "lineName",
          query: true,
        },
        {
          label: this.$t("fbb.headlogistics.container_number", {
            defaultValue: "集装箱号",
          }),
          key: "containerNo",
          query: true,
        },
        {
          label: this.$t("fbb.inbound.cases", { defaultValue: "箱数" }),
          key: "cartonQty",
          query: true,
        },
        {
          label: this.$t("global.common.notes", { defaultValue: "备注" }),
          tag: "vTextarea",
          key: "remark",
          required: false,
        },
        {
          label: this.$t("", { defaultValue: "贴标数",}),
          tag: "vInputNumber",
          key: "labelQty",
          required: false,
          props: {
            min: 0,
            math: "floor",
          },
        },
        {
          label: this.$t("", { defaultValue: "托盘数",}),
          key: "palletQty",
          query: true,
        },
      ];
    },
    // getLogStatus(){
    // 	return {
    // 		'0':'创建',
    // 		'70':'已确认',
    // 		'90':'已取消',
    // 	}
    // },
    getLogColumns() {
      return [
        {
          title: this.$t("global.common.operator", { defaultValue: "操作人" }),
          key: "createdName",
        },
        {
          title: this.$t("global.common.operate_type", {
            defaultValue: "操作类型",
          }),
          key: "opAction",
          render: (h, { row }) => {
            return this.getLogActions[row.operateType] || "";
          },
        },
        {
          title: this.$t("erp.productmanage.tip_reason", {
            defaultValue: "备注",
          }),
          key: "remark",
        },
        {
          title: this.$t("global.common.operate_time", {
            defaultValue: "操作时间",
          }),
          key: "createdAt",
        },
      ];
    },
  },
  methods: {
    //获取计划单详情
    getPlanBillDetail(id) {
      this.loading = true;
      HttpInboundBill({ id })
        .then((res) => {
          this.formData = { ...this.formData, needBox: res.data.needBox };
        })
        .catch((err) => {
          this.loading = false;
          this.$VMessage.error(err.message);
        });
    },
    // 获取执行单详情
    getDetail() {
      this.loading = true;
      HttpInboundOrder({ inboundOrderId: this.id })
        .then((res) => {
          this.formData = res.data;
          this.photoData.orderData = res.data;
          this.photoData.orderType = 3;
          this.getPlanBillDetail(this.formData.inboundPlanOrderId);
          this.getlogList();
        })
        .catch((err) => {
          this.loading = false;
          this.$VMessage.error(err.message);
        });
    },
    //更新入库执行单
    save() {
      HttpUpdateInboundOrder({
        inboundOrderId: this.id,
        sourceNo: this.formData.sourceNo,
        remark: this.formData.remark,
        labelQty: this.formData.labelQty,
      })
        .then((res) => {
          this.loading = true;
          this.cancel();
        })
        .catch((err) => {
          this.loading = false;
          this.$VMessage.error(err.message);
        });
    },
    //日志
    getlogList() {
      if (this.type !== "query") return;
      HttpInboundOrderLogList({
        "search[EQ_orderType]": 430,
        "search[EQ_orderId]": this.id,
      })
        .then((res) => {
          this.logList = res.data;
        })
        .catch((err) => {
          this.loading = false;
          this.$VMessage.error(err.message);
        });
    },
    //确认
    confirm() {
      this.modalProps = {
        show: true,
        alert: "success",
        title: this.$t("global.datepicker.confirm", { defaultValue: "确认" }),
        showDesc: false,
        params: { inboundOrderId: this.id },
        ajaxRequest: HttpConfirmInboundOrder,
        formdata: [
          {
            tag: "vTextarea",
            key: "remark",
            labelWidth: "auto",
            span: 24,
            label: this.$t("global.common.notes", { defaultValue: "备注" }),
            required: false,
          },
        ],
      };
    },
    // 取消订单
    cancelOrder() {
      this.modalProps = {
        show: true,
        alert: "error",
        title: this.$t("global.common.operation_cancel", {
          defaultValue: "取消",
        }),
        showDesc: false,
        params: { inboundOrderId: this.id },
        ajaxRequest: HttpCancelInboundOrder,
        formdata: [
          {
            tag: "vTextarea",
            key: "remark",
            labelWidth: "auto",
            span: 24,
            label: this.$t("fbb.headlogistics.cancel_reason", {
              defaultValue: "取消原因",
            }),
          },
        ],
      };
    },
    // 返回
    cancel() {
      this.$router.push({
        name: "inboundOrder",
      });
    },
  },
};
</script>
